'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteSystem', ['$compile', '$q', 'Session', function($compile, $q, Session) {
    var template = '<div sa-note-shade></div><div sa-note-overlay></div><div sa-note-global-button-box></div>';

    function canRenderTemplate() {
      var deferred = $q.defer();
      var result = true;

      if (!(Session.isLoggedIn() &&
        angular.isDefined(Session.me) &&
        !_.isNull(Session.me))) {
        deferred.resolve(false);

      } else {
        checkRenderPromises()
          .then(function(res) {
            _.each(res, function(bool) {
              result = result && bool;
            });

            deferred.resolve(result);
          }, function(response) {
            console.log('saNoteSystem.checkRenderPromises failed');
            deferred.reject(response);
          });

      }

      return deferred.promise;
    }

    function checkRenderPromises() {
      var promises = [];
      promises.push(Session.isFeatureEnabled('notes'));

      return $q.all(promises);
    }

    return {
      link: function(scope, elem) {
        var exists = false;

        function respond(state) {
          if (exists !== state) {
            if (state) {
              exists = true;
              $(elem).html($compile(template)(scope));
            } else {
              exists = false;
              $(elem).empty();
            }
          }
        }

        var events = ['updatedSessionMe', 'loginStateChanged'];
        lodash.each(events, function(evt) {
          scope.$on(evt, function() {
            canRenderTemplate()
              .then(function(result) {
                respond(result);
              });
          });
        });

        canRenderTemplate()
          .then(function(result) {
            respond(result);
          });
      }
    }
  }]);
